export default from './current-user-avatar-image';



// WEBPACK FOOTER //
// ./app/containers/current-user-avatar-image/index.js